
import moment from "moment";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: { activities: Array, openThis: Function },
})
export default class ActivitySupportRequest extends Vue {
  formatDateTime(stringDate: string) {
    const momentDateTime: any = moment(stringDate);
    return momentDateTime.lang("pt-br").format("HH:mm");
  }

  formatFullDate(stringDate: string) {
    const momentFullDate: any = moment(stringDate);
    return momentFullDate.lang("pt-br").format("DD [de] MMMM [de] YYYY");
  }

  verifyNextDate(object: any, index: any) {
    if (!object[index - 1]) {
      if (this.formatFullDate(object[index].createdAt.date)) {
        return true;
      }
    } else if (object[index - 1]) {
      if (
        this.formatFullDate(object[index - 1].createdAt.date) !=
        this.formatFullDate(object[index].createdAt.date)
      ) {
        return true;
      }
    } else if (object[index + 1]) {
      if (
        this.formatFullDate(object[index].createdAt.date) !=
        this.formatFullDate(object[index + 1].createdAt.date)
      ) {
        return true;
      }
    } else return false;
  }

  getLastAndFirstName(name: string) {
    var str = name;
    var array = str.split(" ");
    return array[0] + " " + array[array.length - 1];
  }

  downloadThis(href: any) {
    var a = document.createElement("a");
    a.href = href;
    a.download = href;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
